import { DataItemType, FormControlType } from "@cloudpivot/form/schema";
import schema from "./schema";
import conduct from "./conduct";
import design from "./components/design.vue";
import pc from './components/dataSelect.vue';
export const info = {
    title: "数据选择",
    type: "data-select",
    icon: "h-icon-all-a-Drop-downsingle-o",
    dataItemType: DataItemType.LongText,
    formControllerType: FormControlType.DataSelect,
    group: "高级控件",
};
export default {
    info,
    schema,
    conduct,
    components: {
        design,
        pc
    },
};
